import { render, staticRenderFns } from "./pt-page-breadcrumb.vue?vue&type=template&id=5716ed32"
import script from "./pt-page-breadcrumb.vue?vue&type=script&lang=js"
export * from "./pt-page-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./pt-page-breadcrumb.vue?vue&type=style&index=0&id=5716ed32&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports